import React__default from 'react';

/**
 * Get a `renderElement` handler for a single type.
 * If the given `type` is equals to the slate element type, render the given `component`.
 * You can pass props by using `rootProps`. Falsy props are ignored.
 */
function getRenderElement({
  type,
  component: Component,
  rootProps
}) {
  return function renderElement({
    attributes,
    element,
    children
  }) {
    if (element.type === type) {
      const htmlAttributes = element === null || element === void 0 ? void 0 : element.attributes;
      return /*#__PURE__*/React__default.createElement(Component, Object.assign({
        attributes: attributes,
        htmlAttributes: htmlAttributes,
        element: element
      }, rootProps), children);
    }
    return undefined;
  };
}

export { getRenderElement };
